<template>
  <div
    class="skeleton"
    :class="[
      { 'skeleton__item': items === 1 },
      { error }
    ]"
  >
    <template v-if="items > 1">
      <div
        v-for="num in items"
        :key="num"
        :class="[ 'skeleton__item', className, { error }]"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'UiSkeleton',
  props: {
    items: { type: Number, default: 1 },
    className: { type: String },
    error: { type: [Object, Boolean, Error] },
  },
}
</script>

<style lang="scss" scoped>
.skeleton {
  &__item {
    width: 100%;
    background: linear-gradient(45deg, #191C25, #191C25, #191C25);
    background-size: 400% 400%;
    animation: smooth-gradient 2s ease infinite;
    border-radius: var(--radius-m);
    opacity: .5;

    @include media(tablet) {
      border-radius: 16px;
    }

    &.error {
      position: relative;
      animation: none;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 80%;
        height: 80%;
        max-height: 64px;
        max-width: 64px;
        background-image: url('/img/error-icon.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        opacity: 0.3;
      }
    }
  }
}
@keyframes smooth-gradient {
  0%{ background-position:100% 0 }
  50%{ background-position:0 100% }
  100%{ background-position:100% 0 }
}
</style>
